import { render, staticRenderFns } from "./HelperTraining.vue?vue&type=template&id=21638210&"
import script from "./HelperTraining.vue?vue&type=script&lang=js&"
export * from "./HelperTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports